// quicktracking ES Module 模式
const originalAky = ['9', '9', 'q', 'o', '7', '7', 'p', 'b', 'p', 'r', '0', '6', 'z', 'g', '5', '1', 'q', '7', 'u', '2', 'v', 't', 'q', 'o'].join('');
const aky = process.env.VUE_APP_RUN_ENV === "pro" ? originalAky : originalAky + '_test';
const trackDomain = 'https://mediadata.xuexi.cn:8443/';
let scriptLoaded = false;
let initialized = false;

function loadScript(callback) {
  if (scriptLoaded) {
    typeof callback === 'function' && callback();
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.id = 'beacon-aplus';
  script.src = 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js';
  script.onload = function() {
    scriptLoaded = true;
    typeof callback === 'function' && callback();
  };
  script.onerror = function() {
    console.error('[QuickTracking] Failed to load SDK script');
  };
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function init(callback) {
  loadScript(function() {
    window.aplus_queue = window.aplus_queue || [];
    window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', aky] });
    window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['trackDomain', trackDomain] });
    initialized = true;
    if (typeof callback === 'function') {
      setTimeout(callback, 0);
    }
  });
}

function push(options, callback) {
  const doPush = function() {
    window.aplus_queue = window.aplus_queue || [];
    window.aplus_queue.push(options);
    if (typeof callback === 'function') {
      setTimeout(callback, 0);
    }
  };
  if (!initialized) {
    init(doPush);
  } else {
    doPush();
  }
}

export default {
  init,
  push
};